import { FC } from 'react';
import { CustomProjectModel } from 'core/domain/project/model/projectModel';
import AlfredMainTemplate from 'components/template/AlfredMainTemplate';
import SpaceAtom from 'components/atoms/SpaceAtom';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import { NotificationOutlined, PlusOutlined } from '@ant-design/icons';
import { useProjects } from './resources/useProjects';
import ConfirmModal from 'components/molecules/ConfirmModal';
import AlfredTableTemplate from 'components/template/AlfredTableTemplate';
import ProjectNotificationModal from 'components/organisms/ProjectNotificationModal';
import ProjectCreateModal from 'components/organisms/ProjectCreateModal';

const ProjectsPage: FC = () => {
  const {
    projects,
    columns,
    loadingProjects,
    totalPages,
    currentPage,
    pageSize,
    translations,
    createProjectModalTranslations,
    createProjectFormData,
    deleteProjectModalTranslations,
    onChangePage,
    onSearch,
    onSelectProject,
    onOpenNotification,
    onCloseNotification,
    onOpenCreateProjectModal,
    onCloseCreateProjectModal,
    onCloseDeleteProjectModal,
    onDeleteProject,
    isUserSuperAdmin,
    isDeleteProjectModalVisible,
    isDeletingProject,
    hasNotificationPermission,
    notificationModalVisible,
    isCreateProjectModalVisible,
  } = useProjects();

  const ActionSection = () => (
    <SpaceAtom>
      {hasNotificationPermission && (
        <DefaultButton
          onClick={onOpenNotification}
          icon={<NotificationOutlined />}
          title={translations.notify}
        />
      )}
    </SpaceAtom>
  );

  const ActionSectionRight = () => (
    <div>
      <DefaultButton
        onClick={onOpenCreateProjectModal}
        icon={<PlusOutlined />}
        title={translations.createProjectButtonText}
        hidden={!isUserSuperAdmin}
      />
    </div>
  );

  return (
    <>
      <AlfredMainTemplate title={translations.projects}>
        <AlfredTableTemplate<CustomProjectModel>
          columns={columns}
          onRowClick={onSelectProject}
          data={projects}
          totalPages={totalPages}
          isCharging={loadingProjects}
          onPagination={onChangePage}
          onSearch={onSearch}
          pageCurrent={currentPage}
          pageSize={pageSize}
          actionSectionRight={<ActionSectionRight />}
          actionSection={<ActionSection />}
        />
      </AlfredMainTemplate>
      <ProjectNotificationModal
        open={notificationModalVisible}
        onCancel={onCloseNotification}
        onOk={onCloseNotification}
      />
      <ProjectCreateModal
        translations={createProjectModalTranslations}
        open={isCreateProjectModalVisible}
        onCancel={onCloseCreateProjectModal}
        formData={createProjectFormData}
      />
      <ConfirmModal
        title={deleteProjectModalTranslations.title}
        text={deleteProjectModalTranslations.text}
        mainButtonText={deleteProjectModalTranslations.mainButtonText}
        secondaryButtonText={deleteProjectModalTranslations.secondaryButtonText}
        onClickMainButton={onDeleteProject}
        onCancel={onCloseDeleteProjectModal}
        visible={isDeleteProjectModalVisible}
        loading={isDeletingProject}
      />
    </>
  );
};

export default ProjectsPage;
